import { render } from "./Create.vue?vue&type=template&id=0e2e23cc"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import "./Create.vue?vue&type=style&index=0&id=0e2e23cc&lang=postcss"
script.render = render

export default script